import { NamedItem, NamedItemInt } from '../../domain/common/namedItem'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'
import { ExpenseTypeEligibility } from '../../domain/expenses/expenseTypeEligibility'
import { RecurringReviewSectionStatus } from '../../domain/expenses/recurringReviewSectionStatus'
import { adminHttpClient } from '../commons/adminHttpClient'

export type RecurringExpenseDetailsForReview = {
  recurringExpenseId: string
  companyUser: CompanyUser
  expenseType: NamedItemInt
  approvedExpenseType?: NamedItemInt
  requestedAmount: number
  approvedAmount?: number
  startDate: string
  approvedStartDate?: string
  endDate?: string
  approvedEndDate?: string
  frequency: NamedItemInt
  approvedFrequency?: RecurringExpenseFrequency
  policyName: string
  description?: string
  expenseNumber: number
  status: NamedItemInt
  lockedBy?: NamedItem
  availableExpenseTypes: ExpenseTypeResponse[]
  attachments: Attachment[]
  planEligibilities: PlanEligibilityResponse[]
  expenseTypeEligibility: ExpenseTypeEligibility
  dateSubmitted: string
  lastReview?: LastReviewResponse
  ineligibleExpenseType: boolean
  reviewHistory?: string
  availableCannedMessages: CannedMessageResponse[]
  availableFrequencies: NamedItemInt[]
  canReview: boolean
  familyMember: NamedItem
  planPeriodId: string
  firstSubmittedOn: string
  lastSubmittedAt?: string
  productId?: number
  productName: string
  hsaCoverage: HsaCoverageForYear[]
}

type PlanEligibilityResponse = {
  startDate: string
  endDate: string
  isInPlanYear: boolean
  reimburseAnotherEmployeePlan: boolean
}

type CompanyUser = {
  id: string
  firstName: string
  lastName: string
  workEmail: string
  workPhone: string
  benefitEligibilityDate?: string
  coveredByHsaInExpenseYear: boolean
}

type ExpenseTypeResponse = {
  id: number
  name: string
  eligibility: ExpenseTypeEligibility
}

type Attachment = {
  id: string
  attachmentId: string
  fileNameUrl: string
  title: string
  reuseInOtherExpenses: boolean
}

type LastReviewResponse = {
  expenseTypeReviewStatus: RecurringReviewSectionStatus
  amountReviewStatus: RecurringReviewSectionStatus
  startDateReviewStatus: RecurringReviewSectionStatus
  frequencyReviewStatus: RecurringReviewSectionStatus
  messageToEmployee?: string
  messageToReviewer?: string
  createdAt: string
  overrideAmount?: number
  overrideStartDate?: string
  overrideFrequency?: RecurringExpenseFrequency
  overrideExpenseTypeId?: number
  overrideEndDate?: string
  endDateReviewStatus: RecurringReviewSectionStatus
  overrideName?: string
  nameReviewStatus: RecurringReviewSectionStatus
}

type CannedMessageResponse = {
  id: string
  title: string
  message: string
}

type HsaCoverageForYear = {
  year: number
  coveredByHsa: boolean
}

const getRecurringExpenseDetailsForReview = (id: string): Promise<RecurringExpenseDetailsForReview> => {
  return adminHttpClient.get(`/Expenses/RecurringExpenseDetailsForReview/${id}`)
}

export default getRecurringExpenseDetailsForReview
